// Copyright © Veeam Software Group GmbH

export const formatStr = (str: string, ...args: any[]): string => str.replace(/{\d+?}/g, (substr: string) => args[+substr.slice(1, -1)]);